import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAuthGuard() {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem('vip_admin_auth');
    if (!auth) {
      navigate('/login');
    }
  }, [navigate]);
}

export function useLoginRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = localStorage.getItem('vip_admin_auth');
    if (auth) {
      navigate('/');
    }
  }, [navigate]);
}